import './_check.scss';
import React from 'react';
import PropTypes from 'prop-types';

import Checkbox from '../../Checkbox/Simple';

const TableBodyCheckbox = ({
  item, rowSpan, values, onChangeCheck, disabled, tdClass,
}) => (
  <td rowSpan={rowSpan} className={tdClass || ''}>
    <Checkbox
      className="input__check"
      disabled={disabled}
      onChangeCheck={onChangeCheck}
      item={item}
      checked={values?.includes(item.id)}
      value={values}
    />
  </td>
);

TableBodyCheckbox.propTypes = {
  item: PropTypes.object,
  rowSpan: PropTypes.number,
  values: PropTypes.array,
  onChangeCheck: PropTypes.func,
  disabled: PropTypes.bool,
  tdClass: PropTypes.string,
}

export default TableBodyCheckbox;
